<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/13QWKif/tc-custom/9781473889750.jpg?1702466396551" alt="This image is the cover for the book Anders' Army"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Anders' Army
      </h1>
      <p class="bookDescription body article font2">
        <p>Along with thousands of his compatriots, Wladyslaw Anders was imprisoned by the Soviets when they attacked Poland with their German allies in 1939. They endured terrible treatment until the German invasion of the Soviet Union in 1941 suddenly put Stalin in the Allied camp, after which they were evacuated to Iran and formed into the Polish Second Corps under Anders command.Once equipped and trained, the corps was eventually committed to the Italian campaign, notably at Monte Cassino. The author assesses Anders performance as a military commander, finding him merely adequate, but his political role was more significant and caused friction in the Allied camp. From the start he often opposed Sikorski, the Polish Prime Minister in exile and Commander in Chief of Polish armed forces in the West. Indeed, Anders was suspected of collusion in Sikorskis death in July 1943 and of later sending Polish death squads into Poland to eliminate opponents, charges that Evan McGilvray investigates. Furthermore, Anders voiced his deep mistrust of Stalin and urged a war against the Soviets after the defeat of Hitler.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Evan McGilvray
      </h2>
      
      <p class="authorDescription body article">Evan McGilvray has written several books on Polish military history for Helion and is writing a book about Poland, NATO and the failure of democracy in Poland since joining the European Union.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Pen and Sword
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?28004399